(() => {
  const CONTAINER_ID = 'ProductGridContainer';
  const REVEAL_CLASS = 'collection-card-row--revealed';
  const INIT_ATTR = 'data-collection-row-fade';

  let io = null;

  function revealRow(li) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        li.classList.add(REVEAL_CLASS);
      });
    });
  }

  function resetIO() {
    if (io) {
      io.disconnect();
      io = null;
    }
  }

  function getIO() {
    if (!io) {
      io = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            const li = entry.target;
            if (!(li instanceof HTMLElement)) continue;
            io.unobserve(li);
            if (!li.classList.contains(REVEAL_CLASS)) revealRow(li);
          }
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0,
        },
      );
    }
    return io;
  }

  function setupRow(li) {
    if (!(li instanceof Element) || !li.matches('li.grid__item')) return;
    if (li.hasAttribute(INIT_ATTR)) return;
    li.setAttribute(INIT_ATTR, '');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      li.classList.add(REVEAL_CLASS);
      return;
    }

    getIO().observe(li);
  }

  function scan(root) {
    if (!root) return;
    root.querySelectorAll?.('#product-grid li.grid__item').forEach(setupRow);
  }

  let containerMO;

  function start() {
    const container = document.getElementById(CONTAINER_ID);
    if (!container) return;

    scan(container);

    if (containerMO) return;

    containerMO = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches('li.grid__item') && node.closest('#product-grid')) setupRow(node);
          node.querySelectorAll?.('li.grid__item').forEach((li) => {
            if (li.closest('#product-grid')) setupRow(li);
          });
        });
      }
    });

    containerMO.observe(container, { childList: true, subtree: true });
  }

  document.addEventListener('facet:product-grid-updated', () => {
    resetIO();
    const container = document.getElementById(CONTAINER_ID);
    if (!container) return;
    container.querySelectorAll('#product-grid li.grid__item').forEach((li) => {
      li.removeAttribute(INIT_ATTR);
      li.classList.remove(REVEAL_CLASS);
    });
    scan(container);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
